import type { Challenge } from "./types.js";
export const progression = {
  firstFinish: 250,
  repeatFinish: 35,
  pb: 100,
  tierMultiplier: 0.45,
  dailyRepeatLimit: 5,
  levelBase: 300,
  levelGrowth: 120,
};
export function levelFor(xp: number) {
  let level = 1;
  while (xp >= levelCost(level)) {
    xp -= levelCost(level);
    level++;
  }
  return level;
}
export function levelCost(level: number) {
  return progression.levelBase + (level - 1) * progression.levelGrowth;
}
export function levelProgress(xp: number) {
  let level = 1;
  while (xp >= levelCost(level)) {
    xp -= levelCost(level);
    level++;
  }
  return { level, current: xp, needed: levelCost(level) };
}
export const challenges: Challenge[] = [
  {
    id: "first",
    name: "First finish",
    description: "Complete your first map",
    period: "permanent",
    metric: "finishes",
    target: 1,
    xp: 150,
  },
  {
    id: "explorer",
    name: "Explore",
    description: "Complete 10 different maps",
    period: "permanent",
    metric: "unique",
    target: 10,
    xp: 600,
  },
  {
    id: "improve",
    name: "Personal best",
    description: "Improve five personal bests",
    period: "permanent",
    metric: "pbs",
    target: 5,
    xp: 300,
  },
  {
    id: "tier2-variety",
    name: "Tier 2 circuit",
    description: "Complete three different tier 2 maps",
    period: "permanent",
    metric: "uniqueTier2",
    target: 3,
    xp: 300,
  },
  {
    id: "tier5-first",
    name: "Tier 5",
    description: "Complete your first tier 5 map",
    period: "permanent",
    metric: "tier5",
    target: 1,
    xp: 500,
  },
];
export const achievements = [
  {
    id: "first",
    name: "FIRST STEPS",
    description: "Complete your first map",
    metric: "finishes",
    target: 1,
    hidden: false,
  },
  {
    id: "ten",
    name: "GETTING THE HANG OF IT",
    description: "Complete 10 unique maps",
    metric: "unique",
    target: 10,
    hidden: false,
  },
  {
    id: "speed",
    name: "SPEED FROG",
    description: "Reach 2,000 u/s",
    metric: "maxSpeed",
    target: 2000,
    hidden: false,
  },
  {
    id: "record",
    name: "RIBBIT RECORD",
    description: "Take your first #1",
    metric: "records",
    target: 1,
    hidden: false,
  },
  {
    id: "grass",
    name: "TOUCH GRASS",
    description: "Play for 100 hours",
    metric: "playtime",
    target: 360000,
    hidden: true,
  },
  {
    id: "hard",
    name: "THE HARD WAY",
    description: "Complete a tier 5 or harder map",
    metric: "tier5",
    target: 1,
    hidden: false,
  },
  {
    id: "why",
    name: "WHY",
    description: "Complete a tier 6 map",
    metric: "tier6",
    target: 1,
    hidden: false,
  },
  {
    id: "master",
    name: "PERFECTIONIST",
    description: "Earn platinum mastery",
    metric: "platinum",
    target: 1,
    hidden: false,
  },
];
export function periodKey(period: string, date = new Date()) {
  if (period === "permanent") return "all";
  if (period === "weekly") {
    date = new Date(date);
    date.setUTCDate(date.getUTCDate() - ((date.getUTCDay() + 6) % 7));
  }
  return date.toISOString().slice(0, 10);
}
